export const Search = {
  DEFAULT: {
    EMPTY: "Нічого не знайдено",
    LOADING: "Шукаю...",
    PLACEHOLDER: "Пошук...",
  },
};
